<div class="snack-bar">
    <div class="profile">
        <img id="icon" src="/assets/images/icons/snackbar/email1.svg" alt="">
        <p>An Email with reset password link has been sent to the user!</p>
    </div>
</div>